import React from 'react';
import { GoogleMap, LoadScript } from '@react-google-maps/api';

export default  ({lat, lng}) => {
  const containerStyle = {
    width: '100%',
    height: '350px'
  };
  const center = {
    lat,
    lng
  };
  return (
    <LoadScript
    googleMapsApiKey="AIzaSyDDCtcdOCh7A1eFBnSJM9mdkbf5KxDNrVE"
  >
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={10}
      clickableIcons={false}
      options={{
        disableDefaultUI: true,
        scaleControl: false,
        zoomControl: false,
        gestureHandling: "none",
        fullscreenControl: false
      }}
    >
      { /* Child components, such as markers, info windows, etc. */ }
      <></>
    </GoogleMap>
  </LoadScript>
  );
};

